<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="-mb-16px">
        <el-form
          ref="searchRefs"
          class="site-filter-form"
          :model="params"
          size="small"
          label-width="70px"
          inline
        >
          <el-form-item label="站点名称" prop="name">
            <el-select
              v-model="params.name"
              filterable
              allow-create
              default-first-option
              clearable
              placeholder="请输入或选择站点名称"
              style="width: 190px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in siteOptions"
                :key="`name-${item.id}`"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点网址" prop="url">
            <el-select
              v-model="params.url"
              filterable
              allow-create
              default-first-option
              clearable
              placeholder="请输入或选择站点网址"
              style="width: 240px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in siteOptions"
                :key="`url-${item.id}`"
                :label="item.url"
                :value="item.url"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户邮箱" prop="email">
            <el-input
              v-model="params.email"
              placeholder="请输入客户邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="站点状态" prop="status">
            <el-select v-model="params.status" placeholder="请选择站点状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="停用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="site-filter-actions ml-6px">
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="mt-16px" v-loading="pager.loading" shadow="never">
      <div>
        <el-button
          v-if="$hasPermission('site', 'create')"
          type="primary"
          size="small"
          @click="onNew"
        >
          新增站点
        </el-button>
      </div>
      <div class="mt-16px">
        <el-table class="site-table" :data="pager.list">
          <el-table-column
            prop="id"
            label="站点ID"
            width="55"
          ></el-table-column>
          <el-table-column label="站点信息" min-width="190">
            <template v-slot="scope">
              <div class="site-summary">
                <strong class="site-summary__name">{{ scope.row.name }}</strong>
                <el-tooltip :content="scope.row.url" placement="top">
                  <span class="site-summary__url">{{ scope.row.url }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="客户邮箱" min-width="200">
            <template v-slot="scope">
              <el-tooltip :content="emailTooltip(scope.row)" placement="top">
                <span class="full-text">{{ emailSummary(scope.row) }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="SEO情况" min-width="150">
            <template v-slot="scope">
              <div class="compact-stack">
                <el-tag
                  size="mini"
                  :type="scope.row.seo_enabled === 1 ? 'success' : 'info'"
                >
                  {{ scope.row.seo_enabled === 1 ? "已开启" : "未开启" }}
                </el-tag>
                <span v-if="scope.row.seo_enabled === 1" class="full-text">
                  承诺{{ scope.row.committed_keyword_count }}个 / 前{{
                    scope.row.committed_rank_limit
                  }}
                </span>
                <span v-else class="full-text">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="CMS" width="100">
            <template v-slot="scope">
              <el-tag
                size="mini"
                :type="cmsTypeTagType(scope.row.cms_type)"
                :class="cmsTypeClass(scope.row.cms_type)"
              >
                {{ cmsTypeText(scope.row.cms_type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Bearer Auth Key" min-width="145">
            <template v-slot="scope">
              <el-tooltip content="点击复制 Bearer Auth Key" placement="top">
                <el-button
                  class="credential-key credential-key--bearer"
                  type="text"
                  size="mini"
                  @click="copyText(scope.row.apikey)"
                >
                  {{ scope.row.apikey || "-" }}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="创建 / 状态" min-width="140">
            <template v-slot="scope">
              <div class="compact-stack">
                <span class="compact-text">
                  {{ formatDate(scope.row.create_time, "yyyy-mm-dd hh:MM:ss") }}
                </span>
                <el-tag size="mini" v-if="scope.row.status === 1">正常</el-tag>
                <el-tag size="mini" type="danger" v-else>停用</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template v-slot="scope">
              <div class="flex items-center">
                <el-button
                  v-if="$hasPermission('site', 'edit')"
                  type="text"
                  @click="onEdit(scope.row.id)"
                >
                  编辑
                </el-button>
                <el-divider
                  v-if="
                    $hasPermission('site', 'edit') &&
                    $hasPermission('site', 'delete')
                  "
                  direction="vertical"
                ></el-divider>
                <popup
                  v-if="$hasPermission('site', 'delete')"
                  :content="`确定删除站点网址为 ${scope.row.url} 的站点？请谨慎操作。`"
                  @confirm="onDelete(scope.row)"
                >
                  <el-button slot="trigger" type="text">删除</el-button>
                </popup>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex justify-between mt-16px">
        <div class="flex"></div>
        <pagination
          v-model="pager"
          :pageSizes="[10, 20, 30]"
          @change="getList()"
        ></pagination>
      </div>
    </el-card>

    <edit-dialog ref="popupRefs" @refresh="getList"></edit-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import Popup from "@/components/popup";
import { Pager } from "@/utils/pager";

import { apiListSite, apiDeleteSite, apiSiteOptions } from "@/api/site";

import EditDialog from "./dialog.vue";
import { formatDate } from "@/utils/util";

export default {
  components: {
    EditDialog,
    Pagination,
    Popup,
  },
  data() {
    return {
      params: {
        name: "",
        url: "",
        email: "",
        status: "",
      },
      siteOptions: [],
      pager: new Pager(),
    };
  },
  created() {
    this.getSiteOptions();
    this.getList();
  },
  methods: {
    formatDate,
    getSiteOptions() {
      apiSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    onReset() {
      this.$refs.searchRefs.resetFields();
      this.getList(1);
    },
    getList(page) {
      page && (this.pager.page = page);
      this.pager.request({
        callback: apiListSite,
        params: {
          ...this.params,
        },
      });
    },
    onNew() {
      this.$refs.popupRefs.openDialog();
    },
    onEdit(id) {
      this.$refs.popupRefs.openDialog(id);
    },
    onDelete(row) {
      apiDeleteSite({
        id: row.id,
      }).then(() => {
        this.$message({
          type: "success",
          message: "删除成功！",
        });
        this.getList();
      });
    },
    emailSummary(row) {
      const emails = Array.isArray(row.emails)
        ? row.emails.filter((item) => String(item || "").trim())
        : [];
      if (!emails.length) return "-";
      return emails.join("，");
    },
    emailTooltip(row) {
      const emails = Array.isArray(row.emails)
        ? row.emails.filter((item) => String(item || "").trim())
        : [];
      return emails.length ? emails.join("，") : "暂无客户邮箱";
    },
    cmsTypeText(value) {
      const map = {
        wordpress: "WordPress",
        eyoucms: "易优CMS",
        unknown: "未知",
      };
      return map[value] || "未知";
    },
    cmsTypeTagType(value) {
      const map = {
        wordpress: "",
        eyoucms: "warning",
        unknown: "info",
      };
      return map[value] || "info";
    },
    cmsTypeClass(value) {
      return value === "wordpress" ? "cms-tag--wordpress" : "";
    },
    copyText(value) {
      const text = String(value || "").trim();
      if (!text) {
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch(() => {
            this.copyTextFallback(text);
          });
        return;
      }
      this.copyTextFallback(text);
    },
    copyTextFallback(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "readonly");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.site-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.site-filter-actions {
  flex: 0 0 auto;
  white-space: nowrap;
}

.site-table {
  width: 100%;
}

.site-table ::v-deep .cell {
  padding-right: 8px;
  padding-left: 8px;
}

.site-summary,
.compact-stack {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.site-summary__name,
.site-summary__url,
.compact-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.site-summary__name {
  color: #303133;
  font-weight: 600;
}

.site-summary__url,
.compact-text {
  color: #606266;
}

.full-text {
  display: block;
  max-width: 100%;
  color: #606266;
  line-height: 18px;
  white-space: normal;
  overflow-wrap: anywhere;
}

.credential-key {
  display: block;
  width: 100%;
  min-width: 0;
  margin-left: 0;
  padding: 3px 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.credential-key--bearer {
  color: #f56c6c;
}

.credential-key--bearer:hover,
.credential-key--bearer:focus {
  color: #f78989;
}

.cms-tag--wordpress {
  color: #21759b;
  background-color: #e9f4f8;
  border-color: #b9d8e5;
}

@media screen and (max-width: 1599px) {
  .site-filter-form ::v-deep .el-form-item {
    margin-right: 12px;
  }
}
</style>
